

















































































































































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { PropSync, Watch } from 'vue-property-decorator'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import TesDatePicker from '@/modules/shared/components/shared/kit/TesDatePicker.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import {
  DepositPayableType,
  DepositResourceType,
  DepositSettlementType
} from '@/modules/deposit/models/deposit-resource.model'
import collect from 'collect.js'
import dayjs from 'dayjs'
import { DateHelper } from '@/modules/shared/helpers/date'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import { BankAccountType } from '@/modules/bank-account/models/bank-account-resource.model'

@Component({
  components: {
    Toggle,
    AdminUserSearch,
    BaseButton,
    CopyableText,
    BaseCard,
    MediaUploader,
    BaseSelect,
    TesDatePicker,
    BaseInput,
    CurrencyInput
  }
})
export default class AdminDepositCreateForm extends Vue {
  constructor(
    private readonly dateHelper: DateHelper
  ) {
    super()
  }

  @PropSync('deposit', { required: true }) depositSync: DepositResourceType
  private isCreate = false
  private depositPayableType = DepositPayableType
  private payableSearchDefault: number[] = []

  mounted() {
    this.isCreate = (!this.depositData.title)
    if (this.isCreate) this.$set(this.depositSync.data, 'paid_at', null)
  }

  //computed
  get depositData() {
    return this.depositSync.data
  }

  get accountTypeOptions() {
    return collect(this.depositSync.account_types).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  get idOptions() {
    return collect(this.depositSync.deposit_bank_accounts).map((item) => ({
      label: item.title,
      value: item.id
    })).toArray()
  }

  get settlementTypeOptions() {
    return collect(this.depositSync.settlement_types).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  get statusOptions() {
    return collect(this.depositSync.statuses).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  get payableOptions() {
    return collect(this.depositSync.payable_types).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  get amountSeparator() {
    return (this.depositData.amount) ? this.depositData.amount.toLocaleString() : ''
  }

  get payableType() {
    return this.depositData.payable_type
  }

  set payableType(value) {
    this.setProperty('payable_id', null)
    this.depositData.payable_type = value
  }

  //watcher
  @Watch('depositSync', { immediate: true, deep: true })
  onChange() {
    this.depositData.reception = this.receptionText()
  }

  //methods
  protected setProperty(key, value) {
    this.$set(this.depositData, key, value)
  }

  receptionText() {
    return (`${this.isUser()} گرامی
پرداختی شما با مشخصات زیر انجام شد
عنوان : ${this.depositData.title || 'ندارد'} ${(!(this.payableType === 'User' || !this.payableType) ? `(${this.depositSync.payable_types[this.payableType]})` : '')}
مبلغ : ${this.amountSeparator} تومان
شماره پیگیری : ${this.depositData.tracking_number || 'ندارد'}
شماره ${(this.settlementType === 'card') ? 'کارت' : 'شبا'} : ${this.depositData[`${(this.settlementType === 'card') ? 'card_number' : 'sheba'}`] || 'ندارد'}
نام صاحب حساب : ${this.depositData.account_owner_name || 'ندارد'}
نوع حساب : ${(this.depositData.account_type === BankAccountType.LEGAL_PERSON) ? 'حقوقی' : 'حقیقی' || 'ندارد'}
تاریخ : ${this.jalaliData(this.depositData.paid_at)}
توضیحات : ${this.depositData.description || 'ندارد'}`) || ''
  }

  get settlementType() {
    switch (this.depositData.settlement_type) {
      case DepositSettlementType.CARD:
        return 'card'
      case DepositSettlementType.CHEQUE:
        return 'cheque'
      case DepositSettlementType.SHEBA:
        return 'sheba'
      default :
        return null
    }
  }

  isUser(): string {
    if (this.payableType === DepositPayableType.USER)
      return 'کاربر'
    else return 'نویسنده'
  }

  jalaliData(value): string {
    return (value) ? dayjs(value).format('HH:mm YYYY/MM/DD') : 'ندارد'
  }

}
